/**
 * Smart backend URL resolution.
 * - Local dev (localhost): use REACT_APP_BACKEND_URL (frontend:3000, backend:8001)
 * - Any deployed env (preview or production): use window.location.origin
 *   so the frontend always calls the same domain it's served from,
 *   regardless of what the stale REACT_APP_BACKEND_URL Kubernetes secret says.
 */
const isLocalDev =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

export const BACKEND_URL = isLocalDev
  ? process.env.REACT_APP_BACKEND_URL
  : window.location.origin;

export const API = `${BACKEND_URL}/api`;
